import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { AutocompleteSelect } from '@candu-ai/analytics/ui';
import { useQueryParams } from 'commons/hooks';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';
import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

type SegmentSearchQuery = { id: string; name: string }[];

type EventSelectItem = {
  value: string;
  label: string;
};

interface EventSelectProps {
  name: string;
  base: string;
  readOnly?: boolean;
}

export const SegmentSelect = ({ name, readOnly }: EventSelectProps) => {
  const params = useParams();
  const queryParams = useQueryParams();
  const { values, setFieldValue } = useFormikContext<DefinitionFormikValues>();

  const segmentId = params.id || queryParams.get('segmentId');

  const apiQuery = useCallback(
    (search: string) => ({
      query: {
        finder: 'bySegmentName',
        q: `${search.trim()}`,
        excludeSegmentId: segmentId,
      },
    }),
    [],
  );

  const getFormattedResults = useCallback((results: SegmentSearchQuery) => {
    return (
      results.map((result) => ({
        value: result.id,
        label: result.name,
      })) || []
    );
  }, []);

  const onChange = useCallback(
    (item) => {
      setFieldValue(name, item.id, false);
    },
    [name],
  );

  return (
    <AutocompleteSelect<EventSelectItem, SegmentSearchQuery, DefinitionFormikValues>
      name={name}
      apiQuery={apiQuery}
      readOnly={readOnly}
      placeholder="Choose a Segment"
      onChange={onChange}
      emptyPlaceholder="You don`t have any Segments yet"
      getFormattedResults={getFormattedResults}
      InputWrapper={SelectInputWrapper}
      values={values}
      setFieldValue={setFieldValue}
    />
  );
};
